import { LayoutSettingsBaseModel } from '..';
import { LayersLayoutSettingsDto } from '../../types';

export default class LayersLayoutSettingsModel extends LayoutSettingsBaseModel {
    readonly minNumberOfLayers: number;
    readonly maxNumberOfLayers: number;
    readonly numberOfLayers: number;

    constructor(data: LayersLayoutSettingsDto) {
        super(data);

        this.minNumberOfLayers = data.minNumberOfLayers;
        this.maxNumberOfLayers = data.maxNumberOfLayers;
        this.numberOfLayers = data.numberOfLayers;
    }

    get label() {
        return 'Layers Layout';
    }

    get dto(): LayersLayoutSettingsDto {
        return {
            type: this.type,
            minNumberOfLayers: this.minNumberOfLayers,
            maxNumberOfLayers: this.maxNumberOfLayers,
            numberOfLayers: this.numberOfLayers
        };
    }
}
